import type { SlotOption } from './types'

interface DocumentOptionPickerProps {
  options: SlotOption[]
  selected: string
  onChange: (key: string) => void
}

/**
 * Radio-style picker for a document slot's option (e.g. Proof of Ownership vs
 * Proof of Purchase). Shared by the Upload Evidence page and the consumer claim
 * evidence checklist (WPS-138 #6).
 */
export function DocumentOptionPicker({
  options,
  selected,
  onChange,
}: DocumentOptionPickerProps) {
  if (options.length === 0) return null

  return (
    <div className="mb-3 space-y-2">
      <p className="clara-small text-[var(--ink-3)]">Document type</p>
      {options.map((opt) => (
        <label
          key={opt.key}
          onClick={() => onChange(opt.key)}
          className={`flex cursor-pointer items-center gap-3 rounded-lg border-[0.5px] px-3.5 py-3 transition-colors duration-150 ${
            selected === opt.key
              ? 'border-[var(--green-border)] bg-[var(--green-bg-subtle)]'
              : 'border-[var(--rule)] hover:border-[var(--rule-strong)]'
          }`}
        >
          <div
            className={`flex h-4 w-4 flex-none items-center justify-center rounded-full border-[1.5px] transition-colors duration-150 ${
              selected === opt.key
                ? 'border-[var(--green)] bg-[var(--green)]'
                : 'border-[var(--rule-heavy)]'
            }`}
          >
            {selected === opt.key && (
              <div className="h-1.5 w-1.5 rounded-full bg-white" />
            )}
          </div>
          <div>
            <span className="text-[13px] font-normal text-[var(--ink)]">
              {opt.label}
            </span>
            {opt.note && (
              <span className="clara-small ml-1.5 text-[var(--ink-3)]">{opt.note}</span>
            )}
          </div>
        </label>
      ))}
    </div>
  )
}
